import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import {
	Controller,
	type Control,
	type UseFormRegister,
	type UseFormWatch,
} from "react-hook-form";
import { useApiQuery } from "src/hooks/useApiQuery";
import type { IAccountData } from "src/Types/account.types";

type IProps = {
	register: UseFormRegister<any>;
	sm?: number;
	md?: number;
	lg?: number;
	watch: UseFormWatch<any>;
	margin?: "normal" | "dense" | "none";
	control?: Control<any, any>;
};
const SelectAccountListByMethod = ({
	register,
	sm,
	md,
	lg,
	watch,
	margin = "none",
	control,
}: IProps) => {
	const paymentMethod = watch && watch("payment_method");
	const { data: accounts = [], isLoading } = useApiQuery<IAccountData[]>({
		endPoint: `/api/fair/admin/account`,
		queryKeys: ["Accounts", paymentMethod],
		params: { ac_type: paymentMethod },
	});
	return (
		<>
			<Grid item xs={12} sm={sm || 6} md={md || 6} lg={lg || 6}>
				<FormControl fullWidth required>
					<InputLabel id='ac-type-label'>Account Type</InputLabel>
					<Controller
						control={control}
						name='payment_method'
						rules={{ required: "Account Type is required!" }}
						render={({ field }) => (
							<Select
								labelId='ac-type-label'
								label='Account Type'
								{...field}
							>
								<MenuItem value='Bank'>Bank</MenuItem>
								<MenuItem value='Cash'>Cash</MenuItem>
								<MenuItem value='Mobile Banking'>
									Mobile Banking
								</MenuItem>
							</Select>
						)}
					/>
				</FormControl>
				{/* <TextField
					fullWidth
					select
					required
					// sx={{ mt: 1 }}
					id='payment_method'
					label='Payment Method'
					variant='outlined'
					{...register("payment_method")}
				>
					{["Mobile Banking", "Cash", "Bank"]?.map((method) => (
						<MenuItem key={method} value={method}>
							{method}
						</MenuItem>
					))}
				</TextField> */}
			</Grid>
			<Grid item xs={12} sm={sm || 6} md={md || 6} lg={lg || 6}>
				<FormControl fullWidth required margin={margin}>
					<InputLabel id='demo-simple-select-label'>
						Account
					</InputLabel>
					<Select
						labelId='demo-simple-select-label'
						id='demo-simple-select'
						{...register("account_id")}
						label='Account'
					>
						{accounts?.map((account) => {
							return (
								<MenuItem
									key={account.ac_id}
									value={account.ac_id}
								>
									{account.ac_bank_name} ({account.ac_name})
								</MenuItem>
							);
						})}
					</Select>
				</FormControl>
			</Grid>
		</>
	);
};

export default SelectAccountListByMethod;
